// use `var` to avoid block scoping
var emplifiHelpers = {
    showReviews: function () {
        // if the review accordion is present, click it to open the reviews section on mobile
        const reviewAccordion = document
            .querySelector('#pdp-reviews-emplifi')
            .querySelector('.js-mobile-accordion-header.mobile-accordion-header');
        // only click to open the accordion if it's not already open, otherwise it will close it
        if (reviewAccordion && !reviewAccordion.classList.contains('active')) {
            try {
                reviewAccordion.click();
            } catch (e) {
                const evt = document.createEvent('MouseEvents');
                evt.initEvent('click', true, true);
                reviewAccordion.dispatchEvent(evt);
            }
        }
        // scroll to the reviews section
        const target = document.getElementById('tt-reviews-summary') ||
            document.getElementById('tt-reviews-list') ||
            document.getElementById('pdp-reviews');
        if (target) {
            setTimeout(function () {
                try {
                    target.scrollIntoView({behavior: 'smooth', block: 'start'});
                } catch (e) {
                    const rect = target.getBoundingClientRect();
                    const top = window.scrollY + rect.top - 20;
                    window.scrollTo({top: top, behavior: 'smooth'});
                }
                if (typeof target.focus === 'function') {
                    target.focus();
                }
            }, 300);
        }
    }
}